import React, { useEffect, useState, useCallback } from "react";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import axios from "axios";
import { RiDeleteBin6Line } from "react-icons/ri";
import { BASE_URL, USER_URL } from "../../constant/api";
import { useSession } from "../../ApiCalls/useSession";
import { IoCloseSharp } from "react-icons/io5";
import CartModal from "../../components/CartModal/CartModal";
import { Link } from "react-router-dom";
import img from "../../assets/seller/loading.png";

function CartCard({ searchQuery }) {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCmodalOpen, setIsCmodalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedMProduct, setSelectedMProduct] = useState(null);
  const [orderSummary, setOrderSummary] = useState({});
  const isCartEmpty = cartItems.length === 0;
  useSession();

  const handleEdit = useCallback((product) => {
    setSelectedMProduct(product);
    setIsCmodalOpen(true);
  }, []);

  const closeCmodal = useCallback(() => {
    setIsCmodalOpen(false);
    setSelectedMProduct(null);
  }, []);

  const openModal = useCallback((product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  }, []);


  const getCart = async () => {
    setLoading(true);
    try {
      const cartResponse = await USER_URL.get(`/orders/cart/`);
      if (cartResponse.data?.items) {
        const updatedItems = await Promise.all(
          cartResponse.data.items.map(async (item) => {
            const productData = await getProductData(item.product_id);
            return { ...item, productData };
          }),
        );
        setCartItems(updatedItems);

        const summaryResponse = await USER_URL.get(`/orders/checkout/`);
        setOrderSummary(summaryResponse.data || {});
        console.log("Order Summary:", summaryResponse.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching cart data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getCart();
  }, []);

  const getProductData = async (productId) => {
    try {
      const response = await axios.get(`${BASE_URL}/products/${productId}/`);
      return response.data.Data[0];
    } catch (error) {
      console.error(`Error fetching product data:`, error);
      return {};
    }
  };

  const MovetoWishlist = async (product_id) => {
    try {
      await USER_URL.post(`/products/cart-wishlist/`, { product_id });
      await getCart();
      closeModal();
    } catch (error) {
      console.error("Error moving to wishlist:", error);
    }
  };

  const handleDeleteCartItem = async (productId) => {
    try {
      await USER_URL.delete(`/orders/cart/`, {
        data: { product_id: productId },
      });
      await getCart();
      closeModal();
    } catch (error) {
      console.error(`Error deleting item:`, error);
    }
  };

  const renderStars = useCallback((rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      const difference = rating - i;
      if (difference >= 0) {
        stars.push(<AiFillStar key={i} className="text-yellow-500" />);
      } else if (difference === -0.5) {
        stars.push(
          <div key={i} className="relative h-5 w-5">
            <AiFillStar
              className="absolute inset-0 text-yellow-500"
              style={{ clipPath: "inset(0 50% 0 0)" }}
            />
            <AiOutlineStar className="absolute inset-0 text-gray-500" />
          </div>,
        );
      } else {
        stars.push(<AiOutlineStar key={i} className="text-gray-500" />);
      }
    }
    return stars;
  }, []);

  return (
    <div className="flex w-full flex-col px-5 lg:flex-row lg:space-x-4">
      {isCartEmpty ? (
        <div className="mt-10 flex w-full flex-col items-center justify-center space-y-4">
          <img src={img} alt="Cart is empty" className="w-52 object-cover" />
          <h2 className="text-2xl font-medium text-gray-700">
            Your Cart Is Empty!
          </h2>
          <Link
            to="/"
            className="mt-4 w-[50%] rounded-lg bg-green-600 py-2 text-center text-white"
          >
            Go To Home
          </Link>
        </div>
      ) : (
        <>
          <div className="w-full flex-col space-y-4 lg:w-3/5">
            {cartItems.filter((item) =>
              item.productData?.name
                ?.toLowerCase()
                .includes(searchQuery.toLowerCase()),
            ).length > 0 ? (
              cartItems
                .filter((item) =>
                  item.productData?.name
                    ?.toLowerCase()
                    .includes(searchQuery.toLowerCase()),
                )
                .map((item, index) => (
                  <div
                    key={item.product_id}
                    className={`flex w-full flex-col items-center rounded-lg border-2 p-4 shadow-lg lg:flex-row ${
                      index % 2 === 0 ? "bg-green-200" : "bg-white"
                    } space-y-4 lg:space-x-4 lg:space-y-0`}
                  >
                    <img
                      src={`${BASE_URL}${item.product_images}`}
                      alt={item.name}
                      className="w-13 h-13 mb-4 lg:mb-0 lg:h-20 lg:w-20"
                    />
                    <div className="flex flex-col items-center text-center md:flex-row md:items-start md:text-left lg:ml-5">
                      <div className="flex-1">
                        <h3 className="text-sm font-bold md:text-base">
                          {item.productData?.name}
                        </h3>
                        <p className="mt-1 line-clamp-1 text-xs text-gray-700">
                          {item.productData?.description}
                        </p>
                        <p className="mt-1 text-xs text-gray-600 lg:text-xs">
                          Category: {item.productData?.category}
                        </p>
                        <div className="mt-2 flex w-full flex-col items-center justify-between space-y-2 md:flex-row md:items-start md:space-y-0">
                          <div className="flex items-center">
                            {renderStars(item.productData?.product_rating || 0)}
                            <span
                              className="text-xs text-gray-600"
                              style={{ fontSize: "10px" }}
                            >
                              {item.productData?.product_rating} (
                              {item.productData?.product_review_count} Reviews)
                            </span>
                          </div>
                          <div className="flex items-center space-x-4 md:ml-5">
                            <div className="rounded-lg border-2 border-gray-300 bg-gray-100 p-1 text-xs font-medium text-gray-700">
                              Qty: {item.quantity}
                            </div>
                            <button
                              onClick={() => handleEdit(item)}
                              className="rounded-lg border-2 border-green-700 bg-green-700 p-1 text-xs font-semibold text-white transition-all hover:bg-green-900"
                            >
                              Qty Change
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex w-full flex-row justify-around md:flex-col lg:w-auto lg:text-right">
                      <button
                        className="mb-0 flex justify-end hover:text-red-500 lg:mb-16"
                        onClick={() => openModal(item)}
                      >
                        <RiDeleteBin6Line size={18} />
                      </button>
                      <h5 className="text-xs font-bold lg:text-sm">
                        {item.productData?.currency_symbol}{item.productData?.price}
                      </h5>
                    </div>
                  </div>
                ))
            ) : (
              <div className="mt-10 text-center text-gray-600">
                <h3 className="text-lg font-semibold">No results found</h3>
                <p>No items found in your cart!</p>
              </div>
            )}
          </div>

          <div className="w-full lg:w-2/5">
            <h5 className="mb-3 text-lg font-bold">Order Summary</h5>
            <div className="rounded-lg border-2 bg-white p-4 text-sm shadow-2xl">
              <div className="mb-2 flex justify-between">
                <span>Items in order</span>
                <span>{cartItems.length}</span>
              </div>
              <hr />
              <div className="mt-2 flex justify-between">
                <span>Actual Price</span>
                <span>{orderSummary.Data?.[0].currency_symbol}{orderSummary.actual_prices}</span>
              </div>
              <div className="mt-2 flex justify-between">
                <span>Offer Price</span>
                <span>{orderSummary.Data?.[0].currency_symbol}{orderSummary.offer_price}</span>
              </div>
              <div className="mt-2 flex justify-between">
                <span>Delivery Charge</span>
                <span>{orderSummary.Data?.[0].currency_symbol}{orderSummary.delivery_charge}</span>
              </div>
              <div className="mt-2 flex justify-between">
                <span>Expected delivery</span>
               {orderSummary.Data?.[0]?.expected_delivery && <span>{orderSummary.Data[0].expected_delivery}</span>} 
              </div>
              <hr />
              <div className="mt-2 flex justify-between font-semibold">
                <span>Sub Total</span>
                <span>{orderSummary.Data?.[0].currency_symbol}{orderSummary.total_price}</span>
              </div>
              <div className="flex justify-center">
                <Link
                  to="/address-selection"
                  className="flex w-full justify-center"
                >
                  <div className="mt-4 w-[50%] rounded-lg bg-green-600 py-2 text-center text-white">
                    Confirm
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </>
      )}

      <CartModal
        selectedMProduct={selectedMProduct}
        isCmodalOpen={isCmodalOpen}
        closeCmodal={closeCmodal}
        onCartUpdate={getCart}
      />

      {isModalOpen && selectedProduct && (
        
        
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-lg md:w-96">
            <div className="mb-4 flex items-center justify-between">
              <h2 className="text-xl font-semibold">
                {selectedProduct.productData?.name}
              </h2>
              <span className="cursor-pointer text-2xl" onClick={closeModal}>
                <IoCloseSharp />
              </span>
            </div>
            <div className="mb-4 flex flex-row items-center">
              <img
                src={`${BASE_URL}${selectedProduct.product_images}`}
                alt={selectedProduct.name}
                className="mb-4 h-24 w-24 rounded-md object-cover lg:h-28 lg:w-28"
              />
              <div className="ml-4 text-start">
                <p className="text-lgr font-medium">
                  {selectedProduct.productData?.name}
                </p>
                <p className="line-clamp-2 text-sm">
                  {selectedProduct.productData?.description}
                </p>
                <div className="flex gap-6">
                  <p className="text-gray-500 line-through">
                    {selectedProduct.productData?.currency_symbol}{selectedProduct.total_price}
                  </p>
                  <p className="text-gray-500">
                    {selectedProduct.productData?.offer_percent}% OFF
                  </p>
                </div>
                <p className="text-xl font-semibold text-brand-primary">
                  {selectedProduct.productData?.currency_symbol}{selectedProduct.productData?.price}
                </p>
              </div>
            </div>
            <div className="mt-4 flex justify-between space-x-4">
              <button
                onClick={() => MovetoWishlist(selectedProduct.product_id)}
                className="w-full rounded border-2 px-2 py-1 text-brand-primary hover:bg-brand-primary hover:text-white"
              >
                Move to Wishlist
              </button>
              <button
                onClick={() => handleDeleteCartItem(selectedProduct.product_id)}
                className="w-full rounded border-2 px-2 py-1 text-red-600 hover:bg-red-600 hover:text-white"
              >
                Delete Permanently
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CartCard;
